export const SORT_DIRECTIONS = {
  ASC: 'asc',
  DESC: 'desc',
};
